// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresPreviewGamesBody = {
  leagueKey: string;
  gridType: "classic" | "shared";
  gameRule: {
    presetKey:
      | "oneGame"
      | "allGames"
      | "tnf"
      | "snf"
      | "mnf"
      | "thanksgiving"
      | "christmas"
      | "playoffs"
      | "conference"
      | "team"
      | "bowls"
      | "cfp"
      | "ncaaTournament"
      | "conferenceTournaments"
      | "openingDay"
      | "worldSeries"
      | "matchdayRange"
      | "customDates";
    seasonYear?: number | null;
    eventId?: string | null;
    teamId?: string | null;
    conferenceKey?: string | null;
    customDates?: {
      mode: "range" | "dates";
      fromDay?: string;
      toDay?: string;
      days?: string[];
    } | null;
    excludedEventIds: string[];
  };
};

export type typeSquaresPreviewGamesOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    window: {
      fromDay: string;
      toDay: string;
      label: string;
      isScheduled: boolean;
    };
    games: {
      eventId: string;
      kickoffAt: string;
      homeTeamId?: string | null;
      awayTeamId?: string | null;
      slotTag?: "tnf" | "snf" | "mnf" | "thanksgiving" | "christmas" | null;
      roundLabel?: string | null;
      isPlaceholder: boolean;
      isStarted: boolean;
      isIncluded: boolean;
    }[];
    matchCount: number;
    includedCount: number;
    expectedMoreCount: number;
    canCreate: boolean;
    needsConfirm: boolean;
    firstLockAt?: string | null;
  };
};

export type typeSquaresPreviewGamesOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresPreviewGamesOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresPreviewGamesOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresPreviewGamesBody = {
  type: "object",
  properties: {
    leagueKey: { type: "string", maxLength: 3000, minLength: 1 },
    gridType: { type: "string", enum: ["classic", "shared"] },
    gameRule: {
      type: "object",
      properties: {
        presetKey: {
          type: "string",
          enum: [
            "oneGame",
            "allGames",
            "tnf",
            "snf",
            "mnf",
            "thanksgiving",
            "christmas",
            "playoffs",
            "conference",
            "team",
            "bowls",
            "cfp",
            "ncaaTournament",
            "conferenceTournaments",
            "openingDay",
            "worldSeries",
            "matchdayRange",
            "customDates",
          ],
        },
        seasonYear: { oneOf: [{ type: "integer" }, { enum: [null] }] },
        eventId: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
        teamId: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
        conferenceKey: {
          oneOf: [
            { type: "string", maxLength: 3000, minLength: 1 },
            { enum: [null] },
          ],
        },
        customDates: {
          oneOf: [
            {
              type: "object",
              properties: {
                mode: { type: "string", enum: ["range", "dates"] },
                fromDay: { type: "string", maxLength: 3000, minLength: 1 },
                toDay: { type: "string", maxLength: 3000, minLength: 1 },
                days: {
                  type: "array",
                  items: { type: "string", maxLength: 3000, minLength: 1 },
                },
              },
              required: ["mode"],
            },
            { enum: [null] },
          ],
        },
        excludedEventIds: {
          type: "array",
          items: { type: "string", maxLength: 3000, minLength: 1 },
        },
      },
      required: ["presetKey", "excludedEventIds"],
    },
  },
  required: ["leagueKey", "gridType", "gameRule"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresPreviewGames(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresPreviewGamesBody);
  }

  return async function postSquaresPreviewGames(
    payload: typeSquaresPreviewGamesBody,
  ): Promise<
    typeSquaresPreviewGamesOutput200 | typeSquaresPreviewGamesOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresPreviewGames" failed before calling the network. #960a5fcf8fb5`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#960a5fcf8fb5" },
        },
        data: null,
      } as typeSquaresPreviewGamesOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/preview-games`,
      httpMethod: "POST",
      options,
    })) as typeSquaresPreviewGamesOutput200 | typeSquaresPreviewGamesOutput400;
  };
}
